(function () {
  if (window.customElements.get('dimensions-facet')) return;
  var D = ['width', 'height'];

  function num(raw) {
    var c = String(raw == null ? '' : raw).replace(/[^0-9.]/g, '');
    if (c === '') return null;
    var v = parseFloat(c);
    return isNaN(v) ? null : v;
  }

  function list(raw) {
    if (!raw) return [];
    return raw.split(',').map(function (t) {
      return { text: t, value: parseFloat(t) };
    }).filter(function (i) {
      return !isNaN(i.value);
    }).sort(function (a, b) {
      return a.value - b.value;
    });
  }

  function banner() {
    var p;
    try { p = new URLSearchParams(window.location.search); } catch (e) { return; }
    function part(label, mn, mx) {
      if (mn && mx) return label + ' ' + mn + '-' + mx + ' cm';
      if (mn) return label + ' from ' + mn + ' cm';
      if (mx) return label + ' up to ' + mx + ' cm';
      return null;
    }
    var bits = [
      part('Width', p.get('dw_min'), p.get('dw_max')),
      part('Height', p.get('dh_min'), p.get('dh_max'))
    ].filter(Boolean);
    var el = document.getElementById('nba-dimension-banner');
    if (!bits.length) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      var h = document.querySelector('.template-search__header h1');
      if (!h) return;
      el = document.createElement('p');
      el.id = 'nba-dimension-banner';
      el.style.cssText = 'text-align:center;margin:1.2rem 0 0;font-size:1.4rem;letter-spacing:0.06rem;opacity:0.75;';
      h.insertAdjacentElement('afterend', el);
    }
    var text = bits.join('   \u00b7   ');
    if (el.textContent !== text) el.textContent = text;
  }

  function sweep() {
    banner();
    var els = document.querySelectorAll('dimensions-facet');
    if (!els.length) return;
    var labels = [];
    [].forEach.call(els, function (el) {
      [el.dataset.widthLabel, el.dataset.heightLabel].forEach(function (l) {
        if (l && labels.indexOf(l) === -1) labels.push(l);
      });
    });
    if (labels.length) {
      [].forEach.call(document.querySelectorAll('.active-facets facet-remove'), function (p) {
        var t = (p.textContent || '').trim();
        for (var i = 0; i < labels.length; i++) {
          if (t.indexOf(labels[i] + ':') === 0) { p.remove(); return; }
        }
      });
    }
    [].forEach.call(els, function (el) {
      if (el.updateCount) el.updateCount();
    });
  }

  var queued = false;
  function queueSweep() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sweep(); });
  }

  function watch() {
    if (window.__nbaDimensionsWatcher) return;
    var o = new MutationObserver(queueSweep);
    o.observe(document.body, { childList: true, subtree: true });
    window.__nbaDimensionsWatcher = o;
  }

  class DimensionsFacet extends HTMLElement {
    connectedCallback() {
      var self = this;
      self.available = { width: list(self.dataset.widthValues), height: list(self.dataset.heightValues) };
      self.params = {};
      self.holders = {};

      D.forEach(function (d) {
        var f = self.querySelector('[data-dimension-field="' + d + '"]');
        if (!f) return;
        self.params[d] = f.name;
        f.disabled = true;
        var h = document.createElement('span');
        h.setAttribute('data-dimension-holder', d);
        h.hidden = true;
        self.appendChild(h);
        self.holders[d] = h;
      });

      self.boxes = [].slice.call(self.querySelectorAll('[data-dimension]'));
      self.boxes.forEach(function (b) {
        b.name = 'd' + (b.dataset.dimension === 'width' ? 'w' : 'h') + '_' + b.dataset.bound;
        b.addEventListener('input', function (e) {
          e.stopPropagation();
          self.dirty = true;
          self.sync();
          self.updateCount();
        });
        b.addEventListener('change', function (e) { e.stopPropagation(); });
        b.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          self.dirty = false;
          self.sync();
          if (det) det.open = false;
          self.submit();
        });
      });

      var det = self.closest('details');
      var reset = (det || self).querySelector('[data-dimension-reset]');
      if (reset) {
        reset.addEventListener('click', function (e) {
          e.preventDefault();
          self.dirty = false;
          self.boxes.forEach(function (b) { b.value = ''; });
          self.sync();
          self.updateCount();
          self.submit();
        });
      }

      var apply = (det || self).querySelector('[data-dimension-apply], .mobile-facets__footer .button--primary');
      if (apply) {
        apply.addEventListener('click', function (e) {
          e.preventDefault();
          self.dirty = false;
          self.sync();
          if (det) det.open = false;
          self.submit();
        });
      }

      self.dirty = false;
      if (det) {
        det.addEventListener('toggle', function () {
          if (det.open || !self.dirty) return;
          self.dirty = false;
          self.submit();
        });
      }

      self.restore();
      self.sync();
      self.updateCount();
      watch();
      queueSweep();
    }

    updateCount() {
      var det = this.closest('details');
      var t = det && det.querySelector('summary .facets__selected');
      if (!t) return;
      var n = 0;
      for (var i = 0; i < D.length; i++) {
        var h = this.holders[D[i]];
        if (h && h.children.length) n++;
      }
      t.textContent = ' (' + n + ')';
      t.classList.toggle('hidden', n === 0);
    }

    restore() {
      var p;
      try { p = new URLSearchParams(window.location.search); } catch (e) { return; }
      this.boxes.forEach(function (b) {
        if (b.value !== '') return;
        var v = p.get(b.name);
        if (v) b.value = v;
      });
    }

    bounds(d) {
      var r = { min: null, max: null };
      this.boxes.forEach(function (b) {
        if (b.dataset.dimension !== d) return;
        r[b.dataset.bound] = num(b.value);
      });
      return r;
    }

    write(d, values) {
      var h = this.holders[d];
      if (!h) return;
      var name = this.params[d];
      var self = this;
      var form = this.closest('form');
      if (form) {
        [].forEach.call(form.querySelectorAll('input[type="checkbox"][name="' + name + '"]'), function (c) {
          if (!self.contains(c)) c.checked = false;
        });
      }
      h.textContent = '';
      values.forEach(function (v) {
        var i = document.createElement('input');
        i.type = 'hidden';
        i.name = name;
        i.value = v;
        h.appendChild(i);
      });
    }

    sync() {
      var self = this;
      D.forEach(function (d) {
        if (!self.holders[d]) return;
        var values = self.available[d];
        var r = self.bounds(d);
        if (r.min === null && r.max === null) return self.write(d, []);
        var lo = r.min === null ? -Infinity : r.min;
        var hi = r.max === null ? Infinity : r.max;
        var sel = values.filter(function (i) {
          return i.value >= lo && i.value <= hi;
        }).map(function (i) { return i.text; });
        if (sel.length === values.length) return self.write(d, []);
        self.write(d, sel.length ? sel : ['-1']);
      });
    }

    submit() {
      var f = this.closest('form');
      if (f) f.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  window.customElements.define('dimensions-facet', DimensionsFacet);
})();